module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    attrs: {
      "id": "visa-payment",
      "action": _vm.visaFormUrl,
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [(!_vm.isLoading) ? _c('button', {
    staticClass: "button-mask",
    on: {
      "click": _vm.onSubmit
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bedc1dfe","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/pasarelas/VisaNet.vue
// module id = 1158
// module chunks = 51